import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import ContentModule from "../../modules/content_module";

import "./LeadooScript.scss";
import { Helmet } from "react-helmet";

const LeadooScript = ({Module}) => {
    return (
        <>
        {Module?.script_code &&
            <section className={`leadoo-script ${Module.bgrd_color ? Module.bgrd_color.toLowerCase() : "" }`}>
                <Container>
                    <Row>
                        <Col>
                            {Module?.title && 
                                <h2>{Module?.title}</h2>
                            }
                            {Module.script_code ? <ContentModule Content={Module.script_code} /> : ""}

                            {Module?.content && <ContentModule Content={Module?.content}/> }
                        </Col>
                    </Row>
                </Container>
            </section>
        }
        </>
    );
};
export default LeadooScript;